import { FC } from 'react';

type Props = {
	className?: string;
};

const InvoiceIconDuotone: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			fill='none'>
			<path
				opacity='0.4'
				d='M3.60156 15.3164V6.84331C3.60156 4.56015 3.60156 3.41857 4.30449 2.70929C5.00742 2 6.13877 2 8.40146 2H11.6014C13.8641 2 14.9954 2 15.6984 2.70929C16.4013 3.41857 16.4013 4.56015 16.4013 6.84331V15.3164C16.4013 16.5257 16.4013 17.1303 16.0317 17.3683C15.4278 17.7574 14.4942 16.9416 14.0246 16.6455C13.6366 16.4008 13.4427 16.2785 13.2274 16.2715C12.9947 16.2638 12.7973 16.3811 12.3781 16.6455L10.8494 17.6096C10.437 17.8696 10.2309 17.9997 10.0014 17.9997C9.772 17.9997 9.56584 17.8696 9.15345 17.6096L7.62478 16.6455C7.23681 16.4008 7.04282 16.2785 6.82752 16.2715C6.59488 16.2638 6.39745 16.3811 5.97821 16.6455C5.50868 16.9416 4.57504 17.7574 3.97111 17.3683C3.60156 17.1303 3.60156 16.5257 3.60156 15.3164Z'
				fill='#2B2B2B'
			/>
			<path
				d='M3.60156 15.3164V6.84331C3.60156 4.56015 3.60156 3.41857 4.30449 2.70929C5.00742 2 6.13877 2 8.40146 2H11.6014C13.8641 2 14.9954 2 15.6984 2.70929C16.4013 3.41857 16.4013 4.56015 16.4013 6.84331V15.3164C16.4013 16.5257 16.4013 17.1303 16.0317 17.3683C15.4278 17.7574 14.4942 16.9416 14.0246 16.6455C13.6366 16.4008 13.4427 16.2785 13.2274 16.2715C12.9947 16.2638 12.7973 16.3811 12.3781 16.6455L10.8494 17.6096C10.437 17.8696 10.2309 17.9997 10.0014 17.9997C9.772 17.9997 9.56584 17.8696 9.15345 17.6096L7.62478 16.6455C7.23681 16.4008 7.04282 16.2785 6.82752 16.2715C6.59488 16.2638 6.39745 16.3811 5.97821 16.6455C5.50868 16.9416 4.57504 17.7574 3.97111 17.3683C3.60156 17.1303 3.60156 16.5257 3.60156 15.3164Z'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.20073 9.19971H6.80078'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11.6007 6H6.80078'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default InvoiceIconDuotone;
